import React from 'react'
import PropTypes from 'prop-types'
import YouTube from '@mui/icons-material/YouTube'

const YouTubeIcon = ({ height, width, ...more }) => {
	
	return (
		<YouTube
			height={height}
			width={width}
			{...more}
		/>
	)
}

YouTubeIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default YouTubeIcon
